export const APP_NAME = "DataView";
export const imageTypes = ["JPG", "JPEG", "PNG", "BMP", "GIF"];

export const checkMobile = () => {
	return window.outerWidth < 800;
};

export const checkLandscape = () => {
	return window.outerWidth > window.outerHeight;
};

export const isNumeric = (val) => {
	if (val === null || isNaN(val)) return false;
	else return true;
};

export const exists = (val) => {
	return val !== null && val !== undefined;
};

export const ifExists = (val, fallback) => {
	if (exists(val)) return val;
	else return fallback;
};

export const compArray = (a1, a2) => {
	return a1.every((val, index) => val === a2[index]);
}

export const includesArray = (arr, target) => { // Search an array of arrays for a value, return true if found
	return arr.some((a) => compArray(a, target));
}